<template>
	<div class="login-register-bg" :style="{height:height}">

		<div class="login-box">
			<img class="left" src="../../assets/images/bg-left.png" />
			<div class="right">
				<p class="welcome">注册账号</p>
				<div class="form">
					<div class="form-group">
						<div class="form-control">
							<input type="text" class="input" placeholder="请输入手机号" v-model="form_data.mobile" />
						</div>
					</div>

					<div class="form-group">
						<div class="form-control">
							<input type="text" class="input" placeholder="请输入手机验证码" v-model="form_data.code" />
							<sms-code class="btn-code" :mobile="form_data.mobile"></sms-code>
						</div>
					</div>

					<div class="form-group">
						<div class="form-control">
							<input type="text" class="input" placeholder="请输入用户名" v-model="form_data.username" />
						</div>
					</div>

					<div class="form-group">
						<div class="form-control" >
							<input :type="is_password_show?'text':'password'" class="input" placeholder="请输入登录密码" v-model="form_data.password" />
							<img @click="toggle_password" class="icon-password" :src="is_password_show ? require('../../assets/images/icon-eye-yes@2x.png'):require('../../assets/images/icon-eye-no@2x.png')" />
						</div>
					</div>

					<div class="form-group">
						<div class="form-control" >
							<input type="text" class="input input-medium" placeholder="请输入姓名" v-model="form_data.realname" />
							<div class="sex-wrap">
								<img @click="change_sex(1)" class="icon-radio" :src="form_data.sex===1 ? require('../../assets/images/icon-radio-yes@2x.png'):require('../../assets/images/icon-radio-no@2x.png')" />男士
								<img @click="change_sex(2)" class="icon-radio" :src="form_data.sex===2 ? require('../../assets/images/icon-radio-yes@2x.png'):require('../../assets/images/icon-radio-no@2x.png')" />女士
							</div>
						</div>
					</div>

					<div class="btn-submit" @click="submit">立即注册</div>

					<p class="bottom1">已有账号 <a @click.stop="go2login" class="btn-login">去登录 &gt; </a></p>

					<p class="bottom2">注册登录即代表同意 <span class="agreement">用户协议</span></p>
				</div>
			</div>

		</div>


	</div>
</template>

<script>
	import SmsCode from "@/components/SmsCode.vue";
	import {
		Register,
		Profile
	} from "@/api/index.js"
	export default {
		name: "Register",
		components: {
			SmsCode
		},
		data() {
			return {
				is_click: false,
				height: '600px',
				form_data: {
					mobile: '',
					code: '',
					username: '',
					password: '',
					realname: '',
					sex: 1,
				},
				is_password_show: false,
			};
		},
		computed: {
			eyeImg() {
				return this.showPassword ?
					require("../../assets/images/hide@2x.png") :
					require("../../assets/images/dieplay@2x.png");
			}
		},
		created() {
			this.height = (window.innerHeight - 78) + 'px'
		},
		methods: {
			submit() {
				if(this.is_click) {
					return
				}
				if(this.form_data.mobile.length===0) {
					this.$layer.msg(`请输入手机号`)
					return
				}
				if(this.form_data.code.length===0) {
					this.$layer.msg(`请输入手机验证码`)
					return
				}

				this.is_click = true
				let promise = new Promise(((resolve) => {
					let response
					response = Register(this.form_data)
					resolve(response)
				}))
				promise.then(response => {
					this.$layer.msg(`注册成功`)
					this.$store.commit('login', response.data)
					return Profile()
				}).then(response => {
					this.$store.commit('setUserInfo', response.data)
				}).then(() => {
					this.$router.replace({name: 'WorkBench'})
				})
				promise.catch((res)=>{
					this.$layer.msg(res.msg)
				})
				promise.finally(() => {
					this.is_click = false
				})



			},
			change_sex(sex) {
				this.form_data.sex = sex
			},
			toggle_password() {
				this.is_password_show = !this.is_password_show;
			},
			go2login() {
				this.$router.replace({name: 'Login'})
			},
			change_type() {
				this.showPassword = !this.showPassword;
			},
		}
	};
</script>

<style scoped lang="scss">
	.login-register-bg {
		width: 100%;
		background-image: url(../../assets/images/bg.png);
		background-size: cover;

		.login-box {
			display: flex;
			width: 720px;
			height: 550px;
			border-radius: 15px;
			position: relative;
			top: 160px;
			left: 600px;
			background: #ffffff;

			.left {
				width: 300px;
				height: 550px;
			}

			.right {
				width: 420px;
				height: 550px;
				position: relative;
				.welcome {
					margin-top: 60px;
					font-size: 20px;
					font-weight: bold;
					font-family: "Microsoft YaHei";
					color: #2C2E30;
					text-align: center;
				}

				.form {
					display: flex;
					flex-wrap: wrap;
					justify-content: center;
					margin-top: 20px;
					.form-group {
						width: 280px;
						height: 50px;
						.form-control {
							position: relative;
							.input {
								width: 100%;
								height: 50px;
								line-height: 50px;
								border:none;
								border-bottom: 1px solid #F0F0F0;
								outline: none;
								&.input-medium {
									width: 160px;
								}
							}

							.btn-code {
								position: absolute;
								top: 12px;
								right: 0;
							}

							.icon-password {
								position: absolute;
								top: 16px;
								right: 0;
								width: 22px;
								height: 16px;
								cursor: pointer;
							}

							.sex-wrap {
								position: absolute;
								top: 16px;
								right: 0;
								width: 120px;
								display: flex;
								cursor: pointer;
								.icon-radio {
									margin-left: 8px;
									width: 20px;
									height: 20px;
								}
							}

						}


					}

					.btn-submit {
						margin: 25px 0;
						width: 280px;
						height: 45px;
						line-height: 45px;
						text-align: center;
						background: #FA3D5A;
						color: white;
						border-radius: 23px;
						cursor: pointer;
					}

					.bottom1 {
						width: 100%;
						text-align: center;
						color: #B1B2B3;
						font-size: 14px;
						.btn-login {
							color: #EE2E47;
						}
					}
					.bottom2 {
						margin-top: 38px;
						width: 100%;
						text-align: center;
						color: #B1B2B3;
						font-size: 12px;
						.agreement {
							color: #3A3C3E;
						}
					}
				}
			}

		}
	}
</style>
